import { Flex, Form, Input } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../Button"

function CreateAlertTicketForm({ onClose, onSubmit }) {
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const onFinish = (values) => {
    onSubmit(values)
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  const validateDescription = (_, value) => {
    if (!value || value.length >= 10) {
      return Promise.resolve()
    }
    return Promise.reject(
      new Error(t("Please provide at least 10 characters to describe the issue."))
    )
  }

  function onFocusHandler(e, fieldName) {
    const field = fieldName || e.target.name || e.target.id
    handleClearError(e, field)
  }

  const validateMessages = {
    required: t("Required fields were not filled.")
  }

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      validateMessages={validateMessages}
      layout="vertical"
      form={form}
    >
      <Form.Item
        name="details"
        label={t("Add details")}
        rules={[{ required: true }, { validator: validateDescription }]}
      >
        <Input.TextArea
          placeholder={t("Describe the issue here...")}
          name="details"
          onFocus={onFocusHandler}
        />
      </Form.Item>

      <Flex gap={16} justify="end" style={{ padding: "0 3px 3px 3px" }}>
        <ButtonComponent size="large" htmlType="button" onClick={onClose}>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent size="large" type="primary" htmlType="submit">
          {t("Send")}
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default CreateAlertTicketForm
